module.exports = __webpack_public_path__ + "img/diaceutics-brand-gradients-04.b8afcadb.png";